import React from 'react'
import { Link } from 'react-router-dom';
import Shape02 from '../../../assets/images/services/personal.png';
import Shape03 from '../../../assets/images/services/debt.png';
import Shape04 from '../../../assets/images/services/money-bag.png';
import Shape05 from '../../../assets/images/services/mortarboard.png';
import Shape06 from '../../../assets/images/services/mortgage-loan.png';
import Shape07 from '../../../assets/images/services/loan.png';
import BG1 from '../../../assets/images/services/service1.png'
import BG2 from '../../../assets/images/services/service2.png'
import BG3 from '../../../assets/images/services/service3.png'
import BG4 from '../../../assets/images/services/service4.png'
import BG5 from '../../../assets/images/services/service5.png'
import BG6 from '../../../assets/images/services/service6.png'
import DOC from '../../../assets/images/services/google-docs.png'
const Servicedata = [
    {
        Image: "flaticon-personal",
        bg: BG1,
        heading: "Security",
        content: "We provide peace of mind by safeguarding your family and property with round-the-clock monitoring and prompt response."
    },
    {
        Image: 'flaticon-money-bag-1',
        bg: BG2,
        heading: "Finance and Accountancy",
        content: "We expertly manage NRI accounts and finances with global framework compliance, tailored services & precise handling."
    },
    {
        Image: "flaticon-money-bag",
        bg: BG3,
        heading: "Real Estate Management",
        content: "Our team offers comprehensive services to ensure NRI properties are well-maintained and their issues are promptly resolved.",
    },
    {
        Image: 'flaticon-mortgage-loan',
        bg: BG5,
        heading: "Legal",
        content: "Your peace of mind is paramount to us, and we're ready to offer the legal guidance and representation you need during trying times."
    },
    {
        Image: 'flaticon-loan-1',
        bg: BG6,
        heading: "Tours & Travel",
        content: "From planned tours to premium hotel and seamless ticket bookings, we ensure stress-free experience from arrival to departure."
    },
    {
        Image: 'flaticon-contract',
        bg: BG6,
        heading: "Documentation",
        content: "From planned tours to premium hotel and seamless ticket bookings, we ensure stress-free experience from arrival to departure."
    },
]
const Servicesone = () => {
    return (
        <section className="services-section-one mt-5">
            {/* <div className="service-one-shape-1">
                <img src={Shape01} alt="shape" />
            </div>
            <div className="service-one-shape-2">
                <img src={Shape00} alt="shape" />
            </div> */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 m-auto">
                        <div className="heading-box text-center">
                            {/* <span className="heading-subtitle wow fadeInUp animated animated">
                                🤝 OUR SERVICES
                            </span> */}
                            <h2 className="heading-title wow fadeInUp animated animated mb-0 pb-0">
                            Local Expertise. Global Impact.
                            </h2>
                            <h6 className='mt-0 pt-0 mb-10 pb-5'>COMPREHENSIVE ARRAY OF SERVICES</h6>
                        </div>
                    </div>
                </div>
                <div className="service-one-inner">
                    {Servicedata.map((data, index) => (
                        <div key={index} className="service-one-box">
                            <div className="service-one-box-image">
                                <img
                                    src={data.bg} alt="service images"
                                />
                               
                            </div>
                            <div className="service-one-icon-box">
                                {/* <img src={data.Image} className="flaticon-personal w-50 h-50 object-fill" alt="icon" /> */}
                                <i className={data.Image}/>
                            </div>
                            <div className="service-one-info">
                                <h4>{data.heading}</h4>
                                <p>
                                    {data.content}
                                </p>
                            </div>
                            <Link to="/Services" className="read-more-btn">
                                <i className="flaticon-next" />
                            </Link>
                        </div>
                    ))}
                </div>
                <div className="text-center">
                    <Link to="/Services" className="btn btn-secondary">
                        View More
                        <i className="flaticon-next" />
                    </Link>
                </div>
            </div>
        </section>

    )
}
export default Servicesone;